import { local } from "../stores/variables"

export function localUrl(localUrl, url) {
	if (local) return url

	let parts = url.split("/");
	parts.forEach((part, i) => {
		if (i > 2) {
			localUrl += "/" + part;
		}
	});
	return localUrl
}
